import { defineAsyncComponent } from 'vue';

export default function install(Vue) {
  Vue.component(
    'Signup',
    defineAsyncComponent(() => import('./index.vue'))
  );
}
